import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useSnackbar } from '@/features/snackbar';

import { mutationFn } from './mutationFn';

import { useNarrative } from '../useNarrative';

type Options = {
  onSuccess?: () => void;
  slug: string;
};

export const useCreateNarrativeAnnouncement = (
  options: Options = { slug: '' }
) => {
  const queryClient = useQueryClient();
  const { addSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: mutationFn,
    onSuccess: (data) => {
      queryClient.setQueryData(
        useNarrative.getOptions({ slug: options.slug }).queryKey,
        (state) => {
          if (typeof state === 'undefined') return state;
          const announcements = state.narrative.announcements || [];
          return {
            narrative: {
              ...state.narrative,
              announcements:
                typeof data !== 'undefined'
                  ? [...announcements, data]
                  : announcements,
            },
          };
        }
      );
      addSnackbar({
        type: 'positive',
        lifeTime: 1000,
        message: 'Narrative announcement successfully created',
      });
      options.onSuccess?.();
    },
    onError: () => {
      addSnackbar({
        type: 'negative',
        lifeTime: 2000,
        message: 'Failed to create narrative',
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries(
        useNarrative.getOptions({ slug: options.slug })
      );
    },
  });
};
